module.exports = __webpack_public_path__ + "static/media/orange-circle.efaaa215.svg";